import {VendorType} from "../../vendor/helpers/VendorType";
import {getPageTitle} from "../utils/get_page_title";

export const titleVendorDetail = (vendorType: VendorType, vendorName: string, cityName?: string) => {
    const base = `${vendorType === VendorType.AGENCY ? "Agencja nieruchomości" : "Deweloper"} ${vendorName}`;
    const withCity = cityName ? `${base} ${cityName}` : base;

    return getPageTitle(withCity);
};
import {VendorType} from "../../vendor/helpers/VendorType";
import {getPageTitle} from "../utils/get_page_title";

export const titleVendorDetail = (vendorType: VendorType, vendorName: string, cityName?: string) => {
    const base = `${vendorType === VendorType.AGENCY ? "Agencja nieruchomości" : "Deweloper"} ${vendorName}`;
    const withCity = cityName ? `${base} ${cityName}` : base;

    return getPageTitle(withCity);
};
